// src/i18n/i18n.js
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nextPlugin } from 'translation-check'

// English translations
import enAlerts from "./locales/en/Alerts.json";
import enCameras from "./locales/en/Cameras.json";
import enDashboard from "./locales/en/Dashboard.json";
import enRules from "./locales/en/Rules.json";
import enSites from "./locales/en/Sites.json";
import enRuleSettings from "./locales/en/RuleSettings.json";
import enZones from "./locales/en/Zones.json";
import enHeader from "./locales/en/Header.json";
import enCommon from "./locales/en/common.json"; 
import enUsers from "./locales/en/Users.json"
import enSettings from "./locales/en/Settings.json"
import enAiAssistant from "./locales/en/AiAssistant.json"

// French translations
import frAlerts from "./locales/fr/Alerts.json";
import frCameras from "./locales/fr/Cameras.json";
import frDashboard from "./locales/fr/Dashboard.json";
import frRules from "./locales/fr/Rules.json";
import frSites from "./locales/fr/Sites.json";
import frRuleSettings from "./locales/fr/RuleSettings.json";
import frZones from "./locales/fr/Zones.json";
import frHeader from "./locales/fr/Header.json";
import frCommon from "./locales/fr/common.json"; 
import frUsers from "./locales/fr/Users.json"
import frSettings from "./locales/fr/Settings.json"
import frAiAssistant from "./locales/fr/AiAssistant.json"




// Arabic translations
import arAlerts from "./locales/ar/Alerts.json";
import arCameras from "./locales/ar/Cameras.json";
import arDashboard from "./locales/ar/Dashboard.json";
import arRules from "./locales/ar/Rules.json";
import arSites from "./locales/ar/Sites.json";
import arRuleSettings from "./locales/ar/RuleSettings.json";
import arZones from "./locales/ar/Zones.json";
import arHeader from "./locales/ar/Header.json";
import arCommon from "./locales/ar/common.json"; 
import arUsers from "./locales/ar/Users.json"
import arSettings from "./locales/ar/Settings.json"
import arAiAssistant from "./locales/ar/AiAssistant.json"

// Chinese translations
import chAlerts       from "./locales/ch/Alerts.json";
import chCameras      from "./locales/ch/Cameras.json";
import chDashboard    from "./locales/ch/Dashboard.json";
import chRules        from "./locales/ch/Rules.json";
import chSites        from "./locales/ch/Sites.json";
import chRuleSettings from "./locales/ch/RuleSettings.json";
import chZones        from "./locales/ch/Zones.json";
import chHeader       from "./locales/ch/Header.json";
import chCommon       from "./locales/ch/common.json"; 
import chUsers        from "./locales/ch/Users.json";
import chSettings     from "./locales/ch/Settings.json";
import chAiAssistant  from "./locales/ch/AiAssistant.json";




const resources = {
  en: {
    common: enCommon, 
    Cameras: enCameras,
    Dashboard: enDashboard,
    Rules: enRules,
    Sites: enSites,
    RuleSettings: enRuleSettings,
    Zones: enZones,
    Header: enHeader,
    Users: enUsers,
    Settings: enSettings,
    Alerts:enAlerts,
    AiAssistant:enAiAssistant
  },
  fr: {
    common: frCommon, 
    Alerts: frAlerts,
    Cameras: frCameras,
    Dashboard: frDashboard,
    Rules: frRules,
    Sites: frSites,
    RuleSettings: frRuleSettings,
    Zones: frZones,
    Header: frHeader,
    Users: frUsers,
    Settings: frSettings,
    AiAssistant:frAiAssistant


  },
  ar: {
    common: arCommon, 
    Alerts: arAlerts,
    Cameras: arCameras,
    Dashboard: arDashboard,
    Rules: arRules,
    Sites: arSites,
    RuleSettings: arRuleSettings,
    Zones: arZones,
    Header: arHeader,
    Users: arUsers,
    Settings: arSettings,
    AiAssistant:arAiAssistant
  },
  ch: {
    common: chCommon, 
    Alerts: chAlerts,
    Cameras: chCameras,
    Dashboard: chDashboard,
    Rules: chRules,
    Sites: chSites,
    RuleSettings: chRuleSettings,
    Zones: chZones,
    Header: chHeader,
    Users: chUsers,
    Settings: chSettings,
    AiAssistant:chAiAssistant
  },
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nextPlugin)
  .init({
    resources,
    supportedLngs: ["en", "fr", "ar", "ch"],
    fallbackLng: "en",
    detection: {
      order: ["navigator", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
    },
    ns: [
      "common",
      "Alerts",
      "Cameras",
      "Dashboard",
      "Rules",
      "Sites",
      "RuleSettings",
      "Zones",
      "Header",
      "Users",
      "Settings",
      "AiAssistant"
    ],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    debug: true,
  })
  .then(() => {
    console.log("i18next initialized with language:", i18next.language);
    // console.log("Available namespaces:", i18next.options.ns);
  })
  .catch((error) => {
    console.error("i18next initialization failed:", error);
  });

i18next.on("languageChanged", (lng) => {
  // console.log("Language changed to:", lng);
  // console.log("Loaded namespaces:", i18next.getResourceBundle(lng));
});

export default i18next;